<template>
  <div>
    <h1>Registrierungen</h1>

    <el-form
      :model="filter"
      @submit.native.prevent
    >
      <el-form-item>
        <el-input
          v-model="filter.search"
          placeholder="Name"
          suffix-icon="el-icon-search"
        />
      </el-form-item>
    </el-form>

    <div>
      <h2>Coaches</h2>

      <c-registration-card
        v-for="coach in coachList"
        :id="coach.profile.id"
        :key="coach.profile.id"
        :name="coach.profile.name"
        type="coach"
        @change="getList"
      />

      <el-card v-if="coachesStatus === $config.status.SUCCESS && !coachList.length">
        <el-alert
          :closable="false"
          show-icon
          :title="coaches.length
            ? 'Zu Ihrer Suche konnten keine passenden Coaches gefunden werden.'
            : 'Es gibt keine neuen Coach-Registrierungen.'
          "
          type="info"
        />
      </el-card>

      <el-card v-if="coachesStatus === $config.status.ERROR">
        <el-alert
          :closable="false"
          show-icon
          title="Die Coach-Registrierungen können zurzeit leider nicht abgerufen werden. Bitte versuchen Sie es später erneut."
          type="error"
        />
      </el-card>
    </div>

    <div>
      <h2>Coachees</h2>

      <c-registration-card
        v-for="coachee in coacheeList"
        :id="coachee.profile.id"
        :key="coachee.profile.id"
        :name="coachee.profile.name"
        type="coachee"
        @change="getList"
      />

      <el-card v-if="coacheesStatus === $config.status.SUCCESS && !coacheeList.length">
        <el-alert
          :closable="false"
          show-icon
          :title="coaches.length
            ? 'Zu Ihrer Suche konnten keine passenden Coachees gefunden werden.'
            : 'Es gibt keine neuen Coachee-Registrierungen.'
          "
          type="info"
        />
      </el-card>

      <el-card v-if="coacheesStatus === $config.status.ERROR">
        <el-alert
          :closable="false"
          show-icon
          title="Die Coachee-Registrierungen können zurzeit leider nicht abgerufen werden. Bitte versuchen Sie es später erneut."
          type="error"
        />
      </el-card>
    </div>
  </div>
</template>

<script>
import CRegistrationCard from '@/components/CRegistrationCard'

import api from '@/api'
import LoadingOverlay from '@/functions/LoadingOverlay'

export default {
  name: 'VRegistrationList',

  metaInfo: {
    title: 'Registrierungen'
  },

  components: {
    CRegistrationCard
  },

  data () {
    return {
      coachesStatus: this.$config.status.IDLE,
      coaches: [],
      coacheesStatus: this.$config.status.IDLE,
      coachees: [],
      filter: {
        search: ''
      }
    }
  },

  computed: {
    coachList () {
      return this.coaches
        .filter(item => item.profile.name
          .toLowerCase()
          .includes(this.filter.search)
        )
    },
    coacheeList () {
      return this.coachees
        .filter(item => item.profile.name
          .toLowerCase()
          .includes(this.filter.search)
        )
    }
  },

  created () {
    this.getList()
  },

  methods: {
    getList () {
      const loadingOverlay = new LoadingOverlay()
      loadingOverlay.start()

      this.coachesStatus = this.$config.status.LOADING
      this.coacheesStatus = this.$config.status.LOADING

      const coachRequest = api.coach
        .getList()
        .then(coaches => {
          this.coaches = coaches.filter(coach => !coach.meta.isApproved)
          this.coachesStatus = this.$config.status.SUCCESS
        })
        .catch(() => {
          this.coachesStatus = this.$config.status.ERROR
        })

      const coacheeRequest = api.coachee
        .getList()
        .then(coachees => {
          this.coachees = coachees.filter(coachee => !coachee.meta.isApproved)
          this.coacheesStatus = this.$config.status.SUCCESS
        })
        .catch(() => {
          this.coacheesStatus = this.$config.status.ERROR
        })

      Promise
        .all([coachRequest, coacheeRequest])
        .finally(() => {
          loadingOverlay.stop()
        })
    }
  }
}
</script>
